import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import NumericalOptions from '../../Common/NumericalOptions/NumericalOptions';
import moment from 'moment';
import en from './locales/en.json';
import fr from './locales/fr.json';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class FlexpassDetailsModal extends Component {
    render() {
        return ( 
            <div>
                <Modal isOpen={this.props.isFlexpassDetailsModalOpen} toggle={this.props.toggleFlexpassDetailsModal}>
                    <ModalHeader tag="h4" toggle={this.props.toggleFlexpassDetailsModal}>{this.props.flexpassDetails.name}</ModalHeader>
                    <ModalBody>
                        <div className="text-left">
                            <p>{this.props.flexpassDetails.description}<br />
                            {this.props.flexpassDetails.tickets_used} of {this.props.flexpassDetails.max_tickets} used</p>
                            
                            {this.props.flexpassDetails.events.length > 0 && (
                                <React.Fragment>
                                    <p><strong>{strings.availableEvents}</strong></p>
                                    <table className="showtix-table showtix-table__striped">
                                        {this.props.flexpassDetails.events.map((event) => (
                                            <tr>
                                                <td>
                                                    {event.name}
                                                </td>
                                                <td>
                                                    {moment(event.date.substring(0, 19)).format('LLLL')}
                                                </td>
                                            </tr>
                                        ))}
                                    </table>
                                </React.Fragment>
                            )}
                        </div>
                        <div className="row mt-3">
                            <div className="col-8 text-left">
                                <div className="showtix-form__group">
                                    <label className="showtix-label" htmlFor="billing_flexpass">{strings.flexpassUse}</label>
                                    <div className="showtix-form__select">
                                        <select 
                                            className="showtix-input"
                                            name="flexpass"
                                            object="amount"
                                            value={this.props.fees_and_discounts.flexpass.amount}
                                            onChange={this.props.handleFlexpassAmount}
                                        >
                                            <NumericalOptions start="1" end={this.props.flexpassDetails.tickets_remaining} />
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </ModalBody>
                    <ModalFooter className="justify-content-center">
                        <button
                            type="button"
                            className="showtix-button showtix-background__primary-1 mt-2 mt-md-0 ml-md-2"
                            onClick={() =>this.props.getCartPricing(this.props.user)}
                        >
                            <span>{strings.apply}</span>
                        </button>
                        <button 
                            className="showtix-button showtix-background__grey-1"
                            onClick={this.props.toggleFlexpassDetailsModal}
                            >{strings.cancel}</button>   
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default FlexpassDetailsModal;


// WEBPACK FOOTER //
// ./src/components/EventListing/FlexpassDetailsModal/FlexpassDetailsModal.js